import React from 'react'
import { ReactComponent as RAISE } from '../../../../lib/assets/icons/raise.svg'
import { ReactComponent as TURN } from '../../../../lib/assets/icons/turn.svg'
import { ReactComponent as RIVER } from '../../../../lib/assets/icons/river.svg'

export const HandlePositionsContent = (
  ante: string,
  raise: string,
  turn: string,
  river: string,
) => {
  const content = [
    {
      title: 'ANTE',
      content: ante,
      icon: '0',
      withBet: ante > '0',
    },
    {
      title: 'RAISE',
      content: raise,
      icon: <RAISE />,
      withBet: raise > '0',
    },
    {
      title: 'TURN',
      content: turn,
      icon: <TURN />,
      withBet: turn > '0',
    },
    {
      title: 'RIVER',
      content: river,
      icon: <RIVER />,
      withBet: river > '0',
    },
  ]

  return content
}
